<template>
  <div class="w-full">
    <img :src="`/static/recruiter/${logo}.jpg`" class="object-cover rounded" :alt="logo">
  </div>
</template>

<script>
export default {
  name: "TestimonialCard",
  props: ['logo']
}
</script>

<style lang="scss" scoped>

</style>
